import React from "react";

export default function SQLServer_CHAR() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_CHAR</h1>
      <p>This is the SQLServer_CHAR component generated from the SQL JSON.</p>
    </div>
  );
}
